import {
    Typography,
    DatePicker,
    Row,
    Image,
    Card,
    Col,
    Tag,
    Pagination,
    Badge,
    Input,
    Space,
    Breadcrumb,
} from "antd";
import {
    FilePdfOutlined,
    ArrowLeftOutlined,
    SoundOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import EditAnnouncement from "./EditAnnouncement";
import ApproveAnnouncement from "./ApproveAnnouncement";

const { Title, Paragraph, Text } = Typography;
const { Search } = Input;

export default function PendingAnnouncements({ onBack }) {
    const [announcements, setAnnouncements] = useState([]);
    const { authData, backUrl } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;

    const [editAnnouncement, setEditAnnouncement] = useState(false);
    const [titleFilter, setTitleFilter] = useState("");
    const [dateFilter, setDateFilter] = useState(null);

    const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(6);

    const [editData, setEditData] = useState(null);

    const fetchAnnouncements = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/hr/announcements/?status=PENDING`,
                { headers: { Authorization: `Bearer ${authData.access}` } }
            );
            setAnnouncements(res.data.results || []);
        } catch (err) {
            console.error("Error fetching announcements:", err);
        }
    };

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const isImageFile = (fileUrl) => {
        if (!fileUrl) return false;
        return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileUrl);
    };

    // Reverse to show latest first
    const reversedAnnouncements = [...announcements].reverse();

    // Apply filters
    const filteredAnnouncements = reversedAnnouncements.filter((item) => {
        const matchTitle = item.title
            .toLowerCase()
            .includes(titleFilter.toLowerCase());

        const matchDate = dateFilter
            ? dayjs(item.created_at).isSame(dateFilter, "day")
            : true;

        return matchTitle && matchDate;
    });

    // Pagination
    const total = filteredAnnouncements.length;
    const paginatedAnnouncements = filteredAnnouncements.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const handleCardClick = (item) => {
        setSelectedAnnouncement(item);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedAnnouncement(null);
        setEditAnnouncement(false);
    };

    const handlePageChange = (page, newPageSize) => {
        setCurrentPage(page);
        if (newPageSize !== pageSize) {
            setPageSize(newPageSize);
            setCurrentPage(1);
        }
    };

    return (
        <>
            {editAnnouncement ? (
                <div style={{ padding: "20px" }}>
                    <ApproveAnnouncement
                        editData={editData}
                        onBack={async () => {
                            setEditAnnouncement(false);
                            // window.location.reload();
                        }}
                    />
                </div>
            ) : (
                <>
                    <Breadcrumb
                        style={{ marginBottom: 16 }}
                        items={[
                            {
                                title: (
                                    <span
                                        style={{ cursor: "pointer", color: "#0e497b" }}
                                        onClick={onBack}
                                    >
                                        <ArrowLeftOutlined /> Back
                                    </span>
                                ),
                            },
                        ]}
                    />
                    <Title
                        level={4}
                        style={{
                            textAlign: "center",
                            marginBottom: "20px",
                            color: "#0e497b",
                        }}
                    >
                        <SoundOutlined style={{ marginRight: 8, color: "#0e497b" }} />
                        Announcements
                    </Title>

                    {
                isMobile ? (
                    <center>
                        <Space style={{ marginBottom: 24, display:'flex', flexDirection:'column' }}>
                            <Search
                                placeholder="Search by Title"
                                onSearch={(value) => setTitleFilter(value)}
                                onChange={(e) => setTitleFilter(e.target.value)}
                                allowClear
                                style={{ width: 250 }}
                            />
                            <DatePicker
                                placeholder="Filter by Created At"
                                onChange={(date) => setDateFilter(date)}
                                style={{ width: 250 }}
                                allowClear
                            />
                        </Space>
                    </center>
                ) : (
                    <center>
                        <Space style={{ marginBottom: 24 }}>
                            <Search
                                placeholder="Search by Title"
                                onSearch={(value) => setTitleFilter(value)}
                                onChange={(e) => setTitleFilter(e.target.value)}
                                allowClear
                                style={{ width: 250 }}
                            />
                            <DatePicker
                                placeholder="Filter by Created At"
                                onChange={(date) => setDateFilter(date)}
                                style={{ width: 250 }}
                                allowClear
                            />
                        </Space>
                    </center>
                )
            }


                    <Row gutter={[24, 24]}>
                        {paginatedAnnouncements.map((item, index) => {
                            const fileUrl = item.announcement_file;

                            const coverContent = fileUrl ? (
                                isImageFile(fileUrl) ? (
                                    <Image
                                        alt={item.title}
                                        src={fileUrl}
                                        height={180}
                                        style={{ objectFit: "cover" }}
                                        preview={false}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            height: 180,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "#fff",
                                            borderRadius: "8px",
                                            color: "#ec0b0b",
                                        }}
                                    >
                                        <FilePdfOutlined style={{ fontSize: 50, color: "red" }} />
                                        <a
                                            href={fileUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ marginTop: 8, color: "#ec0b0b" }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Open & View File
                                        </a>
                                    </div>
                                )
                            ) : (
                                <Image
                                    alt={item.title}
                                    src={item.announcement_image}
                                    height={180}
                                    style={{ objectFit: "cover" }}
                                    preview={false}
                                />
                            );

                            return (
                                <Col key={item.id} xs={24} sm={12} lg={8}>

                                    <Card
                                        hoverable
                                        onClick={() => handleCardClick(item)}
                                        cover={coverContent}
                                        style={{
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                            height: 500,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                        }}
                                        bodyStyle={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            flex: 1,
                                        }}
                                    >

                                        <div style={{ flex: 1 }}>
                                            <Title level={5} ellipsis={{ rows: 1 }}>
                                                {item.title}
                                            </Title>

                                            <Paragraph
                                                ellipsis={{ rows: 3, expandable: false }}
                                                style={{ marginBottom: 12 }}
                                            >
                                                {item.content}
                                            </Paragraph>
                                        </div>

                                        <div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: 8,
                                                }}
                                            >
                                                <Text type="secondary">
                                                    By: {item.created_by_username}
                                                </Text>

                                                <Tag
                                                    color={
                                                        item.status === "APPROVED"
                                                            ? "green"
                                                            : item.status === "PENDING"
                                                                ? "orange"
                                                                : "red"
                                                    }
                                                >
                                                    {item.status}
                                                </Tag>
                                            </div>

                                            <Text type="secondary" style={{ fontSize: "12px" }}>
                                                {dayjs(item.created_at).format("DD/MM/YYYY HH:mm")}
                                            </Text>
                                        </div>
                                        <center>
                                            <a className="my-2" onClick={() => {
                                                setEditData(item)
                                                setEditAnnouncement(true)
                                            }
                                            }>View Content</a>
                                        </center>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>

                    {total > 0 && (
                        <div style={{ textAlign: "center", marginTop: 24 }}>
                            <Pagination
                                current={currentPage}
                                pageSize={pageSize}
                                total={total}
                                onChange={handlePageChange}
                                showSizeChanger
                                pageSizeOptions={["6", "12", "18", "24"]}
                                showTotal={(total, range) =>
                                    `${range[0]}-${range[1]} of ${total} announcements`
                                }
                            />
                        </div>
                    )}
                </>
            )}
        </>
    );
}
